// extracted by mini-css-extract-plugin
export var container = "_5o-0";
export var fallback = "_5o-5";
export var fallbackIcon = "_5o-6";
export var hidden = "_5o-2";
export var image = "_5o-3";
export var loaded = "_5o-4";
export var placeholder = "_5o-1";